<template>
	<ClientOnly>
		<BaseFormSiteForm :fields-config="fieldsConfig" class="ajax_siteform form form-animated-label contact-form" code="contact" v-slot="{fields, loading, status, errors}">
			<template v-if="!status?.success">
				<p v-if="Object.keys(errors)?.length" class="global_error global-error" data-scroll-to-error>
					<BaseCmsLabel code="form_validation_error" />
				</p>
				<BaseFormField v-for="field in fields" :key="field.name" :item="field" v-slot="{errorMessage, floatingLabel}">
					<p class="field" :class="['field-' + field.name, {'ffl-floated': floatingLabel}]">
						<label :for="field.name"><BaseCmsLabel :code="label(field.name)" /></label>
						<BaseFormInput :id="field.name" />
						<span class="field_error error" v-show="errorMessage" v-html="errorMessage" />
					</p>
				</BaseFormField>

				<div class="button-req-cnt">
					<div class="req"><BaseCmsLabel code="request_fields" /></div>
					<button :disabled="loading" type="submit" class="btn btn-primary">
						<UiLoader v-if="loading" />
						<span><BaseCmsLabel code="send" /></span>
					</button>
				</div>
			</template>
			<BaseCmsLabel code="inquiry_success" tag="div" class="contact-form-success" v-show="status?.success" />
		</BaseFormSiteForm>
	</ClientOnly>
</template>

<script setup>
	const labels = useLabels();
	const fieldsConfig = {
		order: ['fullname', 'email', 'phone', 'message'],
	}

	function label(field) {
		let l = labels.get('f_contact_' + field);
		if(!l) l = labels.get(field);
		return l;
	}
</script>

<style scoped lang="less">
	.button-req-cnt{
		display: flex; justify-content: space-between; align-items: center;
		.btn{margin: 0; min-width: 180px; width: 180px;}
	}
	//.req{padding-left: 25px; font-weight: normal; color: rgba(43,44,55,0.5); font-size: 16px; line-height: 21px;}
	.field-subject{display: none!important;}

	@media (max-width: @t){
		.button-req-cnt{
			.btn{min-width: 120px; width: 120px;}
		}
		//.req{padding-left: 20px; font-size: 14px; line-height: 20px;}
	}
	@media (max-width: @m){
		//.req{font-size: 13px; padding-left: 15px;}
		.contact-form-success{font-size: 16px; line-height: 1.2;}
	}
</style>